import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UILink from 'UIComponents/link/UILink';
import { getPaidUserSettingsUrl } from '../../urls/getPaidUserSettingsUrl';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NoResultsFooter = () => {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "routing-ui.reassignment.noResultsFooter.noResults"
    }), /*#__PURE__*/_jsx("p", {
      className: "m-y-0",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "routing-ui.reassignment.noResultsFooter.manageSeatsLink_jsx",
        elements: {
          UILink
        },
        options: {
          external: true,
          href: getPaidUserSettingsUrl(),
          use: 'blue'
        }
      })
    })]
  });
};
NoResultsFooter.displayName = 'NoResultsFooter';
export default NoResultsFooter;